import React, { useState } from "react";
import "./BentoMenu.styles.scss";
import { bentoMenuItems } from "../headerConstants";

interface BentoMenuProps {
	isMobile: boolean;
}

const BentoMenu = (props: BentoMenuProps) => {
	const [isBentoMenuActive, setIsBentoMenuActive] = useState(false);

	return (
		<div className="bento-menu-holder" style={{ marginLeft: props.isMobile ? "auto" : "10px" }}>
			<span
				className={`bento-menu-button circle-button hover ${isBentoMenuActive ? "active" : ""}`}
				onClick={() => setIsBentoMenuActive(!isBentoMenuActive)}
			>
				<img src={require("../../../res/header-icons/bento-menu-icon.svg").default} />
			</span>
			<div className="app-menu bento-menu">
				<ul className="drop-down">
					{bentoMenuItems.map(({ url, title, icon }, index) => (
						<li key={index}>
							<a href={url} title={title} target="_blank">
								<span className="svg-holder">
									<img src={require(`../../../res/header-icons/${icon}`).default} />
								</span>
								<span>{title}</span>
							</a>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default BentoMenu;
